module.exports = __webpack_public_path__ + "static/media/Meeting Attendance.e6353d33.png";